import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/lib/services/common.service';
import { ActionSheetController } from '@ionic/angular';
import { PhotoService } from 'src/app/lib/services/photo.service';
import { UserService } from 'src/app/lib/services/user.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
  standalone: false
})
export class EditProfileComponent implements OnInit {

  userProfileURL: string;
  profileImage: string;
  segment: any;
  userData: any;
  form = {
    basicInformation: {
      personalDetails: {
        // userId:'',
        firstName: '',
        mobileNumber: '',
        secondaryMobileNumber: '',
        profileImage: '',
        // aboutUs: ''
        aboutUs: ''
      }
    }
  };
  customAlertOptions = {
    header: 'user name',
    translucent: true,
  };
  id: any;
  constructor(
    private actionSheetController: ActionSheetController,
    public commonService: CommonService,
    private photoService: PhotoService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userData = this.commonService.userData;
  }

  ionViewWillEnter() {
    this.getUserDetails();
  }


  async addUserDetails() {
    const isLoading = await this.commonService.presentLoader();
    isLoading.present();
    this.userService.addUserDetails(this.form).subscribe((res: any) => {
      isLoading.dismiss();
      if (res.success) {
        this.commonService.success('User Data Updated !!')
        history.back();
      } else if (res && res.error) {
        this.commonService.danger(res.error.message);
      }
    }, err => {
      isLoading.dismiss();
      this.commonService.errorToast(err);
    })
  }


  async getUserDetails() {
    const isLoading = await this.commonService.presentLoader();
    isLoading.present();
    this.userService.getUserDetails().subscribe(res => {
      isLoading.dismiss();
      this.form = {
        basicInformation: {
          personalDetails: {
            firstName: res['data'].basicInformation?.personalDetails.firstName,
            mobileNumber: this.userData.phone,
            secondaryMobileNumber: res['data'].basicInformation?.personalDetails.secondaryMobileNumber,
            profileImage: res['data'].basicInformation?.personalDetails.profileImage ? res['data'].basicInformation?.personalDetails.profileImage : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
            aboutUs: res['data'].basicInformation?.personalDetails.aboutUs
          }
        }
      };
    }, err => {
      isLoading.dismiss();
    })
  }


  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Select Image Source',
      cssClass: 'my-custom-class',
      mode: 'ios',
      buttons: [{
        text: 'Camera',
        handler: () => {
          this.addPhotoToGallery(1);
        }
      }, {
        text: 'Gallery',
        handler: () => {
          this.addPhotoToGallery(0);
        }
      }, {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          // console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  addPhotoToGallery(source: any) {

  }
}